import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export interface UpsertPayload {
  abstractUuid: string;
  abstractData: any;
}

export function useChainUpsertData() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async (payload: UpsertPayload) => {
      const res = await fetch(
        `${
          import.meta.env.VITE_API_URL
        }/bundles/graph_bundle/functions/upsert_chain_abstract_data`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: payload ? JSON.stringify(payload) : '',
        }
      );

      return res.json();
    },
  });
}
